import { html } from "lit-element";
import { findAllElement, findHost, operators } from "@stofloos/utils/sw-constants/index";
import "@stofloos/components/atoms/inputs/input-default";

import "@stofloos/components/atoms/inputs/input-time";
//import "@stofloos/components/atoms/inputs/input-date";

import "@stofloos/components/atoms/inputs/input-select";
import "@stofloos/components/atoms/inputs/input-checkbox";
import "@stofloos/components/atoms/inputs/input-textarea";
import "@stofloos/components/atoms/inputs/input-image-dropzone";
import "@stofloos/components/atoms/inputs/input-checkbox-list";
import "@stofloos/components/atoms/content/sw-content-block";
import "@stofloos/components/atoms/content/sw-event-program";
import "@stofloos/components/atoms/inputs/rich-editor";
import "@stofloos/components/atoms/inputs/json-editor";
import "@stofloos/components/atoms/inputs/form-editor";
import "@stofloos/components/atoms/inputs/input-radiobox";
import "@stofloos/components/atoms/inputs/color-picker";
import "@stofloos/components/atoms/buttons/button-export-xls";
import "@stofloos/components/atoms/buttons/button-submit";
import "@stofloos/components/atoms/buttons/button-text";
import "@stofloos/components/atoms/buttons/button-outlined";
import "@stofloos/components/atoms/buttons/button-contained";
import "@stofloos/components/molecules/inputs/input-subscribe";
import "@stofloos/components/molecules/inputs/input-autocomplete";

import find from "lodash-es/find";
import get from "lodash-es/get";
import set from "lodash-es/set";

import moment from "moment";


// Allows consumers of the sw-form component to provide custom input controls; if the value is changed the custom control
// must call the valueChangeNotifier.
class SWFormInputProviders {
	constructor() {
		this._providers = [];
	}

	getInput(input, data) {
		for (const inputProvider of this._providers) {
			const template = inputProvider(input, data);
			if (template) {
				return template;
			}
		}
	}

	addInputProvider(callback) {
		this._providers.push(callback);
	}

	removeInputProvider(callback) {
		const i = this._providers.indexOf(callback);
		if (i <= 0) {
			this._providers.splice(i, 1);
		}
	}
}

export let swFormInputProviders = new SWFormInputProviders();


const formatTargetGroup = targetGroups => {
	if (targetGroups && targetGroups.length > 0) {
		let newGroup;
		newGroup = targetGroups.map(target => {
			return { name: target, label: target };
		});

		newGroup.unshift({ name: "", label: "" });
		return newGroup;
	}
};

export const template = (self, object, readonly) => html`
	<form class="layout vertical flex" method="post" name="form">
		<div hidden>
			${object && object.id
				? html`
						<input type="number" name="id" value="${object.id}" />
				  `
				: html``}
			${object && object.uuid
				? html`
						<input type="string" name="uuid" value="${object.uuid}" />
				  `
				: html``}
		</div>
		${self.config && self.config.length > 0
			? html`
					${self.summary && self.summary.length
						? html`
								<div class="sw-form-summary-item layout horizontal center-center" @click="${self.toggleForm}">
									<div class="flex layout horizontal center-center">
										${self.summary.map((column, index) => {
											let dataPrefix = self.dataPrefix ? self.dataPrefix : "";
											return html`
												${column.value
													? html`
															<strong class="sw-form-summary-item-label">${column.value}</strong>
													  `
													: html`
															<strong class="sw-form-summary-item-label">${get(object, column.name)}</strong>
													  `}
											`;
										})}
										<sw-icon  style="margin-left: auto;" icon="${self.formIsVisible ? "chevron-up" : "chevron-down"}"></sw-icon>
									</div>
								</div>
						  `
						: html``}
					${self.config.map(row => {
						// THIS IS PROEJCT SPECIFIC FOR EPD
						if (typeof row.visible !== "undefined") {
							if (
								typeof self.object.sections !== "undefined" &&
								find(self.object.sections, "data." + row.visible.target)
							) {
								let dataProperty = get(
									find(self.object.sections, "data." + row.visible.target),
									"data." + row.visible.target
								);
								if (dataProperty.includes(row.visible.value)) {
									let dataPrefix = self.dataPrefix ? self.dataPrefix : "";
									//return rowProcessor(row, get(object, dataPrefix), self.sections, readonly, dataPrefix, self);
								}
							}
						} else {
							let dataPrefix = self.dataPrefix ? self.dataPrefix : "";
							return rowProcessor(row, object, readonly, null, dataPrefix, self);
						}
					})}
			  `
			: html`
					<p>Geen formulier ingeladen.</p>
			  `}
	</form>
`;

export const rowProcessor = (row, data, readonly, inputName, dataPrefix, self) => html`
	<div
		?hidden="${!self.formIsVisible}"
		data-collection="${inputName ? inputName + "-children" : ""}"
		class="${row.class ? row.class + " " : ""}${self.summary && self.summary.length ? " sw-form-summary-item-content " : ""}layout vertical"
	>
		${row.title || row.description
			? html`
					<div>
						<h3>${row.title}</h3>
						<p class="description">${row.description}</p>
					</div>
			  `
			: html``}
		${row.elements && row.elements.length > 0
			? html`
					<div class="layout horizontal wrap">
						${row.elements.map(input => {
							if (input.visible) {
								if (find(sections, [input.visible.target, input.visible.value])) {
									return inputSelector(input, data, readonly, dataPrefix, self);
								} else {
									return;
								}
							} else {
								return inputSelector(input, data, readonly, dataPrefix, self);
							}
						})}
					</div>

					<div data-collection="${inputName ? inputName + "-children" : ""}" class="layout">
						${row.elements.map(input => {
							return input.children && input.children.length > 0
								? html`
										${input.title}
										${input.children.map(childRow =>
											rowProcessor(childRow, data, readonly, input.name, dataPrefix, self)
										)}
								  `
								: html``;
						})}
					</div>
			  `
			: html``}
	</div>
`;

export const inputSelector = (input, data, readonly, dataPrefix, self) => html`
	${input && input.type === "select"
		? html`
				<input-select
					?readonly="${readonly}"
					class="${input.class}"
					?hidden="${input.hidden}"
					data-name="${input.name}"
					cast=${input.cast}
					?required="${input.required}"
					name="${dataPrefix}${input.name}"
					label="${input.label}"
					selected="${get(data, input.name)}"
					.options="${input.options}"
				>
				</input-select>
		  `
		: html``}
	${input && input.type === "textarea"
		? html`
				<input-textarea
					?hidden="${input.hidden}"
					label="${input.label}"
					class="${input.class}"
					type="text"
					?readonly="${readonly}"
					name="${dataPrefix}${input.name}"
					value="${get(data, input.name) ? get(data, input.name) : ""}"
				>
				</input-textarea>
		  `
		: html``}
	${input && input.type === "text"
		? html`
				<input-default
					?readonly="${readonly}"
					?hidden="${input.hidden}"
					data-name="${input.name}"
					class="${input.class}"
					name="${dataPrefix}${input.name}"
					?required="${input.required}"
					value="${get(data, input.name) ? get(data, input.name) : input.default ? input.default : ""}"
					type="${input.type}"
					.label="${input.label ? input.label : null}"
					pattern="${input.pattern ? input.pattern : ""}"
				>
				</input-default>
		  `
		: html``}
		
	${input && input.type === "time"
		? html`
				<input-time
					?readonly="${readonly}"
					?hidden="${input.hidden}"
					data-name="${input.name}"
					class="${input.class}"
					name="${dataPrefix}${input.name}"
					value="${get(data, input.name)
						? moment(get(data, input.name)).format("YYYY-MM-DD")
						: input.default
						? input.default
						: ""}"
					label="${input.label}"
				>
				</input-time>
		  `
		: html``}
		
	${input && input.type === "date"
		? html`
				<input-default
					?readonly="${readonly}"
					?hidden="${input.hidden}"
					data-name="${input.name}"
					class="${input.class}"
					name="${dataPrefix}${input.name}"
					value="${get(data, input.name)
						? moment(get(data, input.name)).format("YYYY-MM-DD")
						: input.default
						? input.default
						: ""}"
					type="${input.type}"
					.label="${input.label ? input.label : null}"
				>
				</input-default>
		  `
		: html``}
	${input && input.type === "number"
		? html`
				<input-default
					?readonly="${readonly}"
					?hidden="${input.hidden}"
					data-name="${input.name}"
					class="${input.class}"
					name="${dataPrefix}${input.name}"
					value="${get(data, input.name) ? get(data, input.name) : input.default ? input.default : ""}"
					type="${input.type}"
					.label="${input.label ? input.label : null}"
					step="${input.step ? input.step : "any"}"
					min="${input.step ? input.min : ""}"
					max="${input.step ? input.max : ""}"
				>
				</input-default>
		  `
		: html``}
	${input && input.type === "radio"
		? html`
				<input-radiobox
					data-name="${input.name}"
					?hidden="${input.hidden}"
					?readonly="${readonly}"
					name="${input.name}[]"
					label="${input.label}"
					.options="${input.options}"
					.values="${get(data, input.name)}"
				>
				</input-radiobox>
		  `
		: html``}
	${input && input.type === "checkbox"
		? html`
				${input.listeners && input.listeners.length > 0
					? html`
							<input-checkbox
								name="${dataPrefix}${input.name}"
								data-value="${get(data, input.name)}"
								?checked="${get(data, input.name) ? get(data, input.name) : input.default}"
								label="${input.label}"
								?hidden="${input.hidden}"
							>
							</input-checkbox>
					  `
					: html`
							<input-checkbox
								name="${dataPrefix}${input.name}"
								data-value="${get(data, input.name)}"
								?checked="${get(data, input.name) ? get(data, input.name) : input.default}"
								label="${input.label}"
								?hidden="${input.hidden}"
							>
							</input-checkbox>
					  `}
		  `
		: html``}
	${input && input.type === "checkbox-list"
		? html`
				<input-checkbox-list
					?readonly="${readonly}"
					?hidden="${input.hidden}"
					data-name="${input.name}[]"
					name="${input.name}"
					label="${input.label}"
					.options="${input.options}"
					.values="${get(data, input.name)}"
				>
				</input-checkbox-list>
		  `
		: html``}
		
	${input && input.type === "select-search"
		? html`
			<input-autocomplete .values="${get(data, input.name) ? get(data, input.name) : []}" label="${input.label}" multiselect="${input.multiselect}" class="${input.class}" name="${input.name}" searchkey="${input.searchkey}" endpoint="${input.endpoint}"></input-autocomplete>
			  `
		: html``}
	
	${input && input.type === "form"
		? html`
			<sw-form
			class="form-section"
			.summary="${input.summary}"
			.formId="${input.selector ? get(data, input.selector) : input.value}"
			.object="${get(data, input.name)}"
			></sw-form>
		  `
		: html``}
	${input && input.type === "form-multiple"
		? html`
				${get(data, input.name) &&
					get(data, input.name).map((item, index) => {
						if (input.mapper) {
							input.mapper.map(mapDefination => {
								set(item, mapDefination.to, get(data, mapDefination.from));
							});
						}
						if (input.selector) {
							input["value"] = get(data, input.selector);
						}
						return html`
							<div style="min-width: 100%;" class="layout horizontal flex">
								${input.config
									? html`
											<sw-form
												class="form-section"
												.summary="${input.summary}"
												.dataPrefix="${dataPrefix}${input.name}[${index}]."
												.config="${input.config}"
												.object="${item}"
											></sw-form>
									  `
									: html`
											<sw-form
												class="form-section"
												.summary="${input.summary}"
												.dataPrefix="${dataPrefix}${input.name}[${index}]."
												.formId="${input.value}"
												.object="${item}"
											></sw-form>
									  `}
								<button-text
									style="margin-left:auto;max-height: 40px;"
									label="verwijderen"
									@click="${() => {
										get(data, input.name) ? get(data, input.name) : set(data, input.name, []);
										get(data, input.name).splice(index, 1);
										self.requestUpdate();
									}}"
								></button-text>
							</div>
						`;
					})}
				<button-text
					style="margin-left:auto;"
					label="${input.button_label ? input.button_label : "nieuw"}"
					@click="${() => {
						get(data, input.name) ? get(data, input.name) : set(data, input.name, []);
						get(data, input.name).push({ title: "Nieuw item" });
						self.requestUpdate();
					}}"
				></button-text>
		  `
		: html``}
	${input && input.type === "image"
		? html`
				<input-image-dropzone
					?isPrivate="${input.private}"
					?single="${input.single}"
					requestId="${input.name}"
					.images="${get(data, input.name) ? get(data, input.name) : ""}"
					class="form-section"
				></input-image-dropzone>
		  `
		: html``}
	${input && input.type === "content_block"
		? html`
				<sw-content-block
					contentId="${input.id}"
					.data="${data}"
					class="form-section ${input.class}"
				></sw-content-block>
		  `
		: html``}
	${input && input.type === "rich-editor"
		? html`
				<rich-editor
					name="${input.name}"
					label="${input.label}"
					.data="${get(data, input.name) ? get(data, input.name) : ""}"
					class="form-section ${input.class}"
				></rich-editor>
		  `
		: html``}
	${input && input.type === "form-editor"
		? html`
				<form-editor
					label="${input.label}"
					name="${dataPrefix}${input.name}"
					.data="${get(data, input.name) ? get(data, input.name) : ""}"
					class="form-section ${input.class}"
				></form-editor>
		  `
		: html``}
	${input && input.type === "json-editor"
		? html`
				<json-editor
					label="${input.label}"
					name="${dataPrefix}${input.name}"
					editor="${input.editor ? input.editor : "default"}"
					.data="${get(data, input.name) ? get(data, input.name) : ""}"
					class="form-section ${input.class}"
				></json-editor>
		  `
		: html``}
	${input && input.type === "subscribe"
		? html`
				<input-subscribe
					.formElement="${self.shadowRoot}"
					name="${input.name}"
					label="${input.label}"
					endpoint="${input.endpoint}"
					.callback="${input.callback}"
					.data="${data}"
					class="form-section ${input.class}"
				></input-subscribe>
		  `
		: html``}
	${input && input.type === "color-picker"
		? html`
				<color-picker
					name="${input.name}"
					label="${input.label}"
					value="${get(data, input.name) ? get(data, input.name) : input.default ? input.default : ""}"
					class="form-section ${input.class}"
				></color-picker>
		  `
		: html``}
	${input && input.type === "submit"
		? html`
				<button-submit
					.formElement="${self.shadowRoot}"
					label="${input.label}"
					endpoint="${input.endpoint}"
					.callback="${input.callback}"
					.data="${data}"
					class="form-section ${input.class}"
				></button-submit>
		  `
		: html``}
	${input && input.type === "button-export-xls"
		? html`
				<button-export-xls
					label="${input.label}"
					endpoint="${input.endpoint}"
					.data="${data}"
					class="form-section ${input.class}"
				></button-export-xls>
		  `
		: html``}
	${input && input.type === "event_program"
		? html`
				<sw-event-program
					.dataPrefix="${dataPrefix}"
					?hideSpots="${input.hideSpots}"
					.program="${get(data, "event_programs")}"
					.enrollments="${get(data, "program_enrollments")}"
					.selectedProgram="${get(data, "program")}"
					class="form-section"
				></sw-event-program>
		  `
		: html``}
	${input && input.type === "event_target_group"
		? html`
				<input-select
					?readonly="${readonly}"
					class="${input.class}"
					?hidden="${input.hidden}"
					data-name="${input.name}"
					?required="${input.required}"
					name="${dataPrefix}${input.name}"
					label="${input.label}"
					selected="${get(data, input.name)}"
					.options="${formatTargetGroup(get(data, "target_groups"))}"
				>
				</input-select>
		  `
		: html``}
		
		${swFormInputProviders.getInput(input, data, self.sections)}
`;
